import React, {useEffect, useState} from 'react';
import deleteIcon from '../images/delete.png';
import emptyIcon from '../images/empty.png';
import axios from 'axios';
import {Link, useNavigate} from 'react-router-dom';
import config from '../config'
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../utils/formatPrice';
import { useCountry } from '../context/CountryContext';

export default function Cart({cart, setCart}) {
    const { t } = useTranslation();
    const { country: selectedCountry, currency } = useCountry();
    const totalPrice = cart.reduce((total, item) =>
        total + (item.installation
                ? (item.product.price + item.product.installationPrice) * item.quantity
                : item.product.price * item.quantity
        ), 0);

    const [email, setEmail] = useState(null);
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [city, setCity] = useState(null);
    const [country, setCountry] = useState(null);
    const [phone, setPhone] = useState(null);
    const [postalCode, setPostalCode] = useState(null);
    const [address, setAddress] = useState(null);
    const [comment, setComment] = useState(null);
    const navigate = useNavigate();
    const [userDetails, setUserDetails] = useState(null);
    const [error, setError] = useState(null);
    const [selectedDelivery, setSelectedDelivery] = useState(null);
    const [deliveryPrice, setDeliveryPrice] = useState(null);
    const token = localStorage.getItem("access_tocken");
const headers = token ? { Authorization: `Bearer ${token}` } : {};

    async function fetchUserDetails() {
        try {
            const response = await axios.get(`${config.API_URL}/api/user/getUserDetails`, {
                headers
            })
            setUserDetails(response.data);
        } catch (error) {
            setUserDetails(null)
        }
    }

    useEffect(() => {
        fetchUserDetails();
    }, [])

    useEffect(() => {
        axios.get(`${config.API_URL}/api/deliveryPrice/getByCountry/${selectedCountry}`)
            .then(response => setDeliveryPrice(response.data))
            .catch(() => setDeliveryPrice(null));
    }, [selectedCountry])

    const grandTotal = totalPrice + (deliveryPrice ? deliveryPrice.price : 0);

    if (cart.length == 0) {
        return (
            <div className='cartEmpty'>
                <p>{t('cart.empty')}</p>
                <img src={emptyIcon}></img>
            </div>
        )
    }

   async function createOrder(e) {
    e.preventDefault();
    
    try {
        const response = await axios.post(`${config.API_URL}/api/order/create`, {
            cart,
            comment,
            user: {
                email: email || userDetails?.email,
                firstName: firstName || userDetails?.firstName,
                lastName: lastName || userDetails?.lastName,
            },
            deliveryDetails: selectedDelivery || {
                city,
                country,
                phone,
                postalCode,
                address
            }
        }, {
            headers
        });
        window.location.href = "https://cedarkids.eu/orderCreated";

    } catch (err) {
        console.error("Error creating order:", err);
        if (err.response && err.response.data && err.response.data.message) {
            setError(err.response.data.message);
        } else {
            setError("Something went wrong. Please try again.");
        }
         setTimeout(() => {
        setError(null);
    }, 5000);
    }
}

    function increaseQuantity(id) {
        setCart(
            cart.map(item =>
                item.product.id == id ? {...item, quantity: item.quantity + 1} : item
            )
        )
    }

    function decreaseQuantity(id) {
        setCart(
            cart.map(item =>
                item.product.id == id && item.quantity > 1 ? {...item, quantity: item.quantity - 1} : item
            )
        )
    }

    function deleteItem(id) {
        setCart(
            cart.filter(item =>
                item.product.id != id
            )
        )
    }

    function toggleInstallation(id) {
        setCart(
            cart.map(item =>
                item.product.id == id ? {...item, installation: !item.installation} : item
            )
        )
    }

    return (
        <>
        {error && (
    <div className="error">
        <p>{error}</p>
        <button onClick={() => setError(null)}>✖</button>
    </div>
)}
            <div className='container'>
                <div className='cart'>
                    <ul>
                        {cart.map(item => (
                            <li key={item.product.id}>
                                <img src={item.product.image} alt='none image'></img>
                                <div className='text-area'>
                                    <p>{item.product.name}</p>
                                    <div className='installation'>
                                        <input type='checkbox' checked={item.installation} onChange={() => toggleInstallation(item.product.id)}/>
                                        <p>{t('product.installation')} + {formatPrice(item.product.installationPrice, currency)}</p>
                                    </div>
                                </div>
                                <div className='counters'>
                                    <button onClick={() => decreaseQuantity(item.product.id)}>-</button>
                                    <p>{item.quantity}</p>
                                    <button onClick={() => increaseQuantity(item.product.id)}>+</button>
                                </div>
                                <p>{formatPrice(item.installation ? (item.product.price + item.product.installationPrice) * item.quantity : item.product.price * item.quantity, currency)}</p>
                                <button onClick={() => deleteItem(item.product.id)}><img src={deleteIcon}/></button>
                            </li>
                        ))}
                        <form>
                            <p>{t('cart.delivery')}</p>
                            {userDetails == null && (
                                <>
                                    <input onChange={(e) => setFirstName(e.target.value)} placeholder={t('cart.firstName')}
                                           name='firstName' required/>
                                    <input onChange={(e) => setLastName(e.target.value)} placeholder={t('cart.lastName')}
                                           name='lastName' required/>
                                    <input onChange={(e) => setEmail(e.target.value)} placeholder={t('cart.email')} name='email'
                                           required/>
                                    <input onChange={(e) => setPhone(e.target.value)} placeholder={t('cart.phone')} name='phone'
                                           required/>
                                    <input onChange={(e) => setCountry(e.target.value)} placeholder={t('cart.country')}
                                           name='country'
                                           required/>
                                    <input onChange={(e) => setCity(e.target.value)} placeholder={t('cart.city')} name='city'
                                           required/>
                                    <input onChange={(e) => setPostalCode(e.target.value)} placeholder={t('cart.postalCode')}
                                           name='postalCode' required/>
                                    <input onChange={(e) => setAddress(e.target.value)} placeholder={t('cart.address')}
                                           name='adress'
                                           required/>
                                           <input onChange={(e) => setComment(e.target.value)} placeholder={t('Comment')}
                                           name='comment'
                                           required/>
                                </>
                            )}
                            {userDetails != null && Array.isArray(userDetails.deliveryDetails) && (
                                <ul key={selectedDelivery?.id || 'no-selection'}>
                                    <button onClick={() => navigate('/user')}>{t('cart.addNewAddress')}</button>
                                    {userDetails.deliveryDetails.map((item) => (
                                        <li style={{border: selectedDelivery?.id === item.id ? '2px solid green' : '1 px solid rgb(121, 227, 121)'}}
                                            onClick={() => {
                                                setSelectedDelivery(item);
                                                console.log("Selected delivery: ", item);
                                            }} key={item.id}>
                                            <p>{t('cart.phone')}: {item.phone}</p>
                                            <p>{t('cart.country')}: {item.country}</p>
                                            <p>{t('cart.city')}: {item.city}</p>
                                            <p>{t('cart.address')}: {item.address}</p>
                                            <p>{t('cart.postalCode')}: {item.postalCode}</p>
                                        </li>
                                    ))}
                                      <input onChange={(e) => setComment(e.target.value)} placeholder={t('Comment')}
                                           name='comment'
                                          />
                                </ul>
                                
                            )}
                            {userDetails != null && userDetails.deliveryDetails.length == 0 && (

                                <>
                                    <input onChange={(e) => setPhone(e.target.value)} placeholder={t('cart.phone')} name='phone'
                                           required/>
                                    <input onChange={(e) => setCountry(e.target.value)} placeholder={t('cart.country')}
                                           name='country'
                                           required/>
                                    <input onChange={(e) => setCity(e.target.value)} placeholder={t('cart.city')} name='city'
                                           required/>
                                    <input onChange={(e) => setPostalCode(e.target.value)} placeholder={t('cart.postalCode')}
                                           name='postalCode' required/>
                                    <input onChange={(e) => setAddress(e.target.value)} placeholder={t('cart.address')}
                                           name='adress'
                                           required/>
                                             <input onChange={(e) => setComment(e.target.value)} placeholder={t('Comment')}
                                           name='comment'
                                           />
                                </>
                            )}
                        </form>
                    </ul>
                    <div className='shipment'>
                        <p>{t('cart.summary')}</p>
                        <p>{deliveryPrice ? `${t('cart.delivery')}: ${formatPrice(deliveryPrice.price, deliveryPrice.currency)}` : t('cart.deliveryFree')}</p>
                        <p>{t('cart.total')}: {formatPrice(grandTotal, currency)}</p>
                        <Link onClick={createOrder}>{t('cart.buy')}</Link>
                        <Link to="/">{t('cart.continue')}</Link>
                    </div>
                </div>
            </div>
        </>
    )
}
